<template>
  <div class="risk-info">
    <span class="risk-info-text" id="max-ind-risk" title="">
      R<sub>m(max)</sub>:
      <span
        class="risk-info-value"
        v-if="!oldData"
        :style="{ color: maxIndRisk > legalIndRisk ? 'red' : 'green' }"
        v-html="toNormal(maxIndRisk)"
      />
      <span class="risk-info-value" v-else>0</span>

      <main-tooltip target="max-ind-risk" tooltipValue="Максимальный индивидуальный пожарный риск на объекте защиты" />
    </span>

    <span class="risk-info-text" id="res-ind-risk">
      R<sub>(max)</sub>:
      <span
        class="risk-info-value"
        v-if="!oldData"
        :style="{ color: maxIndRiskRes > legalResIndRisk ? 'red' : 'green' }"
        v-html="toNormal(maxIndRiskRes)"
      />
      <span class="risk-info-value" v-else>0</span>

      <main-tooltip
        target="res-ind-risk"
        tooltipValue="Максимальный индивидуальный пожарный риск в жилой зоне, общественно-деловой зоне или зоне рекреационного назначения вблизи объекта"
      />
    </span>

    <span class="risk-info-text" id="res-soc-risk">
      S<sub>(max)</sub>:
      <span
        class="risk-info-value"
        v-if="!oldData"
        :style="{ color: maxSocialRisk > legalResSocRisk ? 'red' : 'green' }"
        v-html="toNormal(maxSocialRisk)"
      />
      <span class="risk-info-value" v-else>0</span>
      <main-tooltip
        target="res-soc-risk"
        tooltipValue="Максимальный социальный пожарный риск в жилой зоне, общественно-деловой зоне или зоне рекреационного назначения вблизи объекта"
      />
    </span>
  </div>
</template>

<script>
import MainTooltip from "./ui/MainTooltip.vue";
export default {
  components: { MainTooltip },
  props: {
    oldData: Boolean,
    maxIndRisk: Number,
    legalIndRisk: Number,

    legalResIndRisk: Number,
    maxIndRiskRes: Number,

    maxSocialRisk: Number,
    legalResSocRisk: Number,

    toNormal: Function,
  },
};
</script>

<style scoped>
.risk-info {
  position: absolute;
  top: 60px;
  left: 21px;
  width: max-content;
  display: flex;
  flex-direction: column;
  background-color: var(--white-color);
  padding: 8px;
  gap: 12px;
  z-index: 10;
  min-width: 112px;
}

.risk-info-text {
  font-size: 12px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: var(--black-color);
}

.risk-info-value {
  margin-left: auto;
}
</style>
